import PonduranceIcon from './PonduranceIcon';

export default PonduranceIcon;
